<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" :val="headerTitle"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section>
          <div class="guideMsg ac">
            <p class="txtL">회원님의 정보를 안전하게 보호하기 위해 비밀번호를 다시 한번 확인합니다.</p>
          </div>
          <div class="formArea">
            <div class="iptWrap">
              <input
                type="password"
                id="ipt3"
                class="ipt uiAct"
                placeholder="비밀번호를 입력해주세요."
                title="비밀번호 입력(비밀번호를 입력해주세요.)"
                value=""
                v-model="password"
              />
              <button class="btnIco_del" tabindex="-1">
                <span class="blind">해당 필드 입력값 삭제</span>
              </button>
            </div>
          </div>

          <!-- btnArea (s) -->
          <div class="btnArea mt20">
            <button type="button" class="btn_p" @click="checkUser">확인</button>
          </div>
          <!-- btnArea (e) -->
        </section>
      </div>

      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
    <MessagePop v-if="messagePop" @close="close">
      <p v-html="msg"></p>
    </MessagePop>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import JwtService from '@/common/jwt.service';
import MessagePop from '@/components/popup/MessagePop';

export default {
  name: 'authAccount',
  components: {
    MessagePop,
  },
  mounted() {
    this.userInfo = JwtService.getUserInfo();
    console.log(this.userInfo);
  },
  data: function() {
    return {
      headerTitle: '회원정보수정',
      password: '',
      userInfo: null,
      messagePop: false,
      msg: null,
    };
  },
  methods: {
    nextStep: function() {
      this.$router.push({ name: 'changeUserInfo' });
    },
    checkUser: function() {
      if (!this.password) {
        this.msg = '비밀번호를 입력해주세요.';
        this.messagePop = true;
        return false;
      }
      ApiService.service('POST', 'user/auth/password/check', {
        request: {
          password: this.password,
        },
        serviceType: 'app',
      })
        .then(({ data }) => {
          // console.log(data);
          if (data.isSucceed) {
            this.nextStep();
          } else {
            this.msg = data.error;
            this.messagePop = true;
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    close() {
      this.messagePop = false;
    },
  },
};
</script>
